// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"dc6a7176","232":"57970c3e","268":"e434dbbb","613":"41bcb9bb","807":"e7ea6e18"}[chunkId] + ".chunk.js";
};